import { client } from '../client';
import { IGMCreateVideoTokenPayload } from './types/IGMCreateVideoTokenPayload';

export const getVideoToken = async (payload: IGMCreateVideoTokenPayload): Promise<string> => {
  const { data } = await client.post(`/videos/access_token`, payload);

  return data.access_token;
};
